import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navLinkClass = "text-gray-400 hover:text-white link-underline py-2 text-sm font-medium transition-colors";

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-surface/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2.5">
            <img src="https://sunserv.fr/assets/icon.png" alt="SunServ Logo" className="w-7 h-7" />
            <span className="text-lg font-bold text-white" style={{ fontFamily: 'var(--font-display)' }}>
              Sun<span className="text-yellow-400">Serv</span>
              <span className="text-xs text-gray-500 ml-1.5 font-normal tracking-wider uppercase">Blog</span>
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-6">
            <Link to="/" className={navLinkClass}>
              <i className="fas fa-home mr-1.5"></i>Accueil
            </Link>
            <Link to="/contributors" className={navLinkClass}>
              <i className="fas fa-trophy mr-1.5"></i>Contributeurs
            </Link>
            <a href="https://sunserv.fr" className={navLinkClass}>
              <i className="fas fa-globe mr-1.5"></i>Site Principal
            </a>
            <a href="https://sunserv.fr/shop" className={navLinkClass}>
              <i className="fas fa-gamepad mr-1.5"></i>Serveurs de jeu
            </a>
            <a href="https://sunserv.fr/shop/vps" className={navLinkClass}>
              <i className="fas fa-server mr-1.5"></i>VPS
            </a>
            <Link to="/login" className={navLinkClass}>
              <i className="fas fa-pen mr-1.5"></i>Contribuer
            </Link>
            <Link
              to="/register"
              className="bg-yellow-400 text-gray-900 px-4 py-1.5 rounded-md text-sm font-semibold hover:brightness-110 transition-all"
            >
              <i className="fas fa-user-plus mr-1.5"></i>S'inscrire
            </Link>
          </div>

          {/* Mobile toggle */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-gray-400 hover:text-white"
          >
            <i className={`fas ${mobileMenuOpen ? 'fa-times' : 'fa-bars'} text-xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-surface/95 border-t border-gray-700/20 backdrop-blur-md">
          <Link to="/" className="block px-4 py-3 text-gray-300 hover:bg-surface-raised hover:text-white transition-colors" onClick={() => setMobileMenuOpen(false)}>
            <i className="fas fa-home mr-2"></i>Accueil
          </Link>
          <Link to="/contributors" className="block px-4 py-3 text-gray-300 hover:bg-surface-raised hover:text-white transition-colors" onClick={() => setMobileMenuOpen(false)}>
            <i className="fas fa-trophy mr-2"></i>Contributeurs
          </Link>
          <a href="https://sunserv.fr" className="block px-4 py-3 text-gray-300 hover:bg-surface-raised hover:text-white transition-colors">
            <i className="fas fa-globe mr-2"></i>Site Principal
          </a>
          <a href="https://sunserv.fr/shop" className="block px-4 py-3 text-gray-300 hover:bg-surface-raised hover:text-white transition-colors">
            <i className="fas fa-gamepad mr-2"></i>Serveurs de jeu
          </a>
          <a href="https://sunserv.fr/shop/vps" className="block px-4 py-3 text-gray-300 hover:bg-surface-raised hover:text-white transition-colors">
            <i className="fas fa-server mr-2"></i>VPS
          </a>
          <Link to="/login" className="block px-4 py-3 text-gray-300 hover:bg-surface-raised hover:text-white transition-colors" onClick={() => setMobileMenuOpen(false)}>
            <i className="fas fa-pen mr-2"></i>Contribuer
          </Link>
          <div className="p-3 space-y-2">
            <Link to="/register" className="block text-center px-4 py-2.5 bg-yellow-400 text-gray-900 font-semibold rounded-md text-sm" onClick={() => setMobileMenuOpen(false)}>
              <i className="fas fa-user-plus mr-2"></i>S'inscrire
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Header;
